import { modulesConfig } from '@/containers/SubscriptionFormPageNew/config'
import { isBreakManagementAvailable } from '@/containers/BreakManagementPage/isBreakManagementAvailable'

export default function modulesIsActive(key, modulesStatus, country, isExternal = false, commonData = {}) {
  if (modulesStatus === null) {
    return false
  }
  switch (key) {
    case 'assistanceProducts':
      return modulesStatus['assistance-options'] ?? false
    case 'monConseillerPersoProducts':
      return modulesStatus['mon-conseiller-perso-options'] ?? false
    case 'carbonOffset':
      return modulesStatus['carbon-offset'] ?? false
    case 'form':
      return modulesConfig[country]?.menu?.legacyFormLink ?? true
    case 'formV2':
      if (isExternal) return true
      return modulesConfig[country]?.menu?.legacyFormLink ?? true
    case 'clientCallbacks':
      return modulesConfig[country]?.menu?.callbacks ?? false
    case 'breaks':
      return isBreakManagementAvailable({ country, commonData })
    case 'italyFiscalCodes':
      return country === 'it'
    default:
      return true
  }
}
